// extracted by mini-css-extract-plugin
export var closed = "_b7-1";
export var resizer = "_b7-0";